import React, { useState, useRef, useEffect } from 'react';
import { useTripContext } from '../../contexts/TripContext';

// AI suggestion prompts
const AI_SUGGESTIONS = [
  { icon: 'fa-utensils', text: 'Week-long trip to a city with great food' },
  { icon: 'fa-plane', text: 'Nonstop weekend escape' },
  { icon: 'fa-briefcase', text: 'International trip in Business class' },
];

/**
 * SearchBox - Main search input with AI suggestions panel
 */
const SearchBox = () => {
  const { startChatWithQuery } = useTripContext();
  const [searchValue, setSearchValue] = useState('');
  const [isExpanded, setIsExpanded] = useState(false);
  const containerRef = useRef(null);

  // Close suggestions when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsExpanded(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSearch = () => {
    if (searchValue.trim()) {
      startChatWithQuery(searchValue);
      setSearchValue('');
      setIsExpanded(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const handleSuggestionClick = (suggestion) => {
    startChatWithQuery(suggestion);
    setIsExpanded(false);
  };

  return (
    <div 
      className={`search-container ${isExpanded ? 'expanded' : ''}`}
      ref={containerRef}
    >
      <div className="search-input-wrapper">
        <input
          type="text"
          className="search-input"
          placeholder="When, where, and how do you want to travel?"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          onFocus={() => setIsExpanded(true)}
          onKeyPress={handleKeyPress}
        />
        <button className="search-btn" onClick={handleSearch}>
          <i className="fas fa-arrow-right"></i>
        </button>
      </div>

      {/* AI Suggestions Panel */}
      <div className="ai-suggestions-panel">
        {AI_SUGGESTIONS.map((suggestion, index) => (
          <div
            key={index}
            className="suggestion-item"
            onClick={() => handleSuggestionClick(suggestion.text)}
          >
            <i className={`fas ${suggestion.icon}`}></i>
            <span>{suggestion.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SearchBox;
